import { uncapitalize } from '@attain-apps/string-utils'

import * as core from '../../../../../../core'
import * as common from '../../../../../common'

import * as subawardRisk from './subaward-risk'

// NOTE: everything below is designed to simulate a normal folder/module
// structure for exporting resources from separate files. This just simply
// generates those resources based on the known enum entries

const enumId = core.dms.models.Enum.Id.from({
  partialId: subawardRisk.RESOURCE.payload.partialId,
})

const enumEntryResourceNameLookup = {} as Record<common.SubawardRisk, string>
for (const enumEntryName in common.SubawardRisk) {
  const potentialEnum =
    common.SubawardRisk[enumEntryName as keyof typeof common.SubawardRisk]
  if (common.SubawardRisk.isSubawardRisk(potentialEnum)) {
    enumEntryResourceNameLookup[potentialEnum] = uncapitalize(enumEntryName)
  }
}

export const entries = common.SubawardRisk.ALL.reduce(
  (prev, _subawardRisk) =>
    Object.assign(prev, {
      [enumEntryResourceNameLookup[_subawardRisk]]: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        RESOURCE: {
          payload: {
            ...common.SubawardRisk.getEntry(_subawardRisk),
            enumId,
          },
          type: core.quiver.Resource.Type.DmsEnumEntry,
        } as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>,
      },
    }),
  {} as {
    [K in keyof typeof common.SubawardRisk as (typeof common.SubawardRisk)[K] extends common.SubawardRisk
      ? Uncapitalize<K>
      : never]: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      RESOURCE: core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
    }
  },
)
